

/*============== IMPORT BOOTSTRAP ===========*/
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

/*============== IMPORT OWL CAROUSEL ===========*/
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';

/*============== IMPORT FONT AWESOME ===========*/
import '../assets/css/all.css';

/*============== IMPORT MAGNIFIC POPUP ===========*/
import 'magnific-popup';
import 'magnific-popup/dist/magnific-popup.css';

/*============== IMPORT MAIN STYLE & RESPONSIVE CSS ===========*/
import '../assets/css/style.css';
import '../assets/css/responsive.css';

/*============== IMPORT VUE SCROLL MAGIC ===========*/

import VueScrollmagic from 'vue-scrollmagic';

/*============== IMPORT GLOBAL DIRECTIVES ===========*/
import globalDirectives from "./globalDirectives";

export default {
  install(Vue) {
    Vue.use(VueScrollmagic);
    Vue.use(globalDirectives);
  }
};



// WEBPACK FOOTER //
// ./src/plugins/vPizzleKit.js